import React, { useEffect, useState, useContext } from 'react';
import { MyContext } from '../context/MyContext';
import { callApiPost, getCsv } from '../Helper/Network';

import { HyappDatePicker, HyappSelect } from '../Helper/Form';
import { toast } from 'react-toastify';

import { Button } from 'react-bulma-components';
import { useTranslation } from '../locale/useTranslation';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const convertDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1);
    const day = (date.getDate());
    return year.toString() + "-" + month.toString().padStart(2, '0') + "-" + day.toString().padStart(2, '0');
}

function Export() {
    const { t, language, setLanguage } = useTranslation();
    const { selectedEtablissement } = useContext(MyContext);
    var df = new Date();
    df.setHours(0, 0, 0, 0);
    df.setMonth(df.getMonth() - 1)
    var dt = new Date();
    dt.setHours(0, 0, 0, 0);

    const [modules, setModules] = useState([]);
    const [dateFrom, setDateFrom] = useState(convertDate(df));
    const [dateTo, setDateTo] = useState(convertDate(dt));
    const [dataType, setDataType] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);

    const exportData = async () => {
        try {
            const response = await callApiPost("/etablissement/" + selectedEtablissement.id + "/export", {
                from: dateFrom,
                to: dateTo,
                dataType: dataType.tech
            }, null);

            const { data, headers } = response;

            const headerLabels = headers.map(h => t(h.label));
              
            const rows = data.map(row =>
                headers.map(h => {
                let value = row[h.value];
                if (value == null) return '';

                // Si translate = true, on applique t()
                if (h.translate) {
                    return t(String(value));
                }

                return value;
                })
            );

            // Conversion du tableau d'objets en format compatible Excel
            const worksheetData = [
                headerLabels, // première ligne = entêtes
                ...rows
            ];

            // Création de la feuille
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

            const columnWidths = headerLabels.map(label => ({ wch: Math.max(15, label.length + 2) }));
            worksheet['!cols'] = columnWidths;

            // Création du classeur
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, t("Données"));

            // Génération du fichier Excel en mémoire
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            // Téléchargement automatique du fichier
            const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
            saveAs(blob, `export_${dataType.label}-${dateFrom}-${dateTo}.xlsx`);

            
        }
        catch (error) { //in case of error display toast
            toast.error(error.statusText);
        }
    };

    useEffect(() => {
        if (firstLoad) {
            const multiSelect = [];
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("reception")) { multiSelect.push({value: 1, label:t("Réceptions"), tech: "reception"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_temperature_stockage")) { multiSelect.push({value: 2, label:t("Relevés des températures de stockage"), tech: "releve_temperature_stockage"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("tracabilite")) { multiSelect.push({value: 3, label:t("Tracabilités"), tech: "tracabilite"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_refroidissement")) { multiSelect.push({value: 4, label:t("Refroidissements"), tech: "releve_refroidissement"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("remise_temp")) { multiSelect.push({value: 5, label:t("Remises T°C"), tech: "remise_temp"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_huile")) { multiSelect.push({value: 6, label:t("Huiles"), tech: "releve_huile"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("nettoyage")) { multiSelect.push({value: 7, label:t("Nettoyages"), tech: "nettoyage"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("temp_service")) { multiSelect.push({value: 8, label:t("Températures de service"), tech: "temp_service"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("mixe")) { multiSelect.push({value: 9, label:t("Mixés"), tech: "mixe"}) }

            setModules(multiSelect);
            setFirstLoad(false);
        }
        //do Nothing
    }, []);

    useEffect(() => {
            const multiSelect = [];
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("reception")) { multiSelect.push({value: 1, label:t("Réceptions"), tech: "reception"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_temperature_stockage")) { multiSelect.push({value: 2, label:t("Relevés des températures de stockage"), tech: "releve_temperature_stockage"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("tracabilite")) { multiSelect.push({value: 3, label:t("Tracabilités"), tech: "tracabilite"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_refroidissement")) { multiSelect.push({value: 4, label:t("Refroidissements"), tech: "releve_refroidissement"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("remise_temp")) { multiSelect.push({value: 5, label:t("Remises T°C"), tech: "remise_temp"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("releve_huile")) { multiSelect.push({value: 6, label:t("Huiles"), tech: "releve_huile"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("nettoyage")) { multiSelect.push({value: 7, label:t("Nettoyages"), tech: "nettoyage"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("temp_service")) { multiSelect.push({value: 8, label:t("Températures de service"), tech: "temp_service"}) }
            if (selectedEtablissement.modules != null && selectedEtablissement.modules.includes("mixe")) { multiSelect.push({value: 9, label:t("Mixés"), tech: "mixe"}) }

            setModules(multiSelect);
    }, [language])

    return (
        <>
            <div className="columns">
                <div className="column">
                    <h1 className="hyappTitle">{t("Exporter les données")}</h1>
                </div>
            </div>
            <div className="columns is-multiline is-vcentered">
                <div className="column is-one-fifth label-right">
                    <label className="label">{t("Du :")}</label>
                </div>
                <div className="column is-four-fifths edit-value">
                    <HyappDatePicker value={dateFrom} callback={setDateFrom} />
                </div>
                <div className="column is-one-fifth label-right">
                    <label className="label">{t("Au :")}</label>
                </div>
                <div className="column is-four-fifths edit-value">
                    <HyappDatePicker value={dateTo} callback={setDateTo} />
                </div>
                
                <HyappSelect label={"Type de données"} data={modules} callback={setDataType} value={dataType}/>
                
            </div>
            <Button className="button is-success" onClick={exportData}>{t("Exporter les données")}</Button>
        </>
    );
}

export default Export;